import { IoClose } from "react-icons/io5";
import { MdOutlineHealthAndSafety } from "react-icons/md";

const SendPrescriptionDialog = ({ open, onClose, handleSend, dataProduct }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/10 backdrop-blur-sm">
      <div className="w-full max-w-lg bg-white rounded-2xl shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <div className="flex items-center gap-2">
            <span className="text-red-600">
              <MdOutlineHealthAndSafety size={20} />
            </span>
            <h2 className="font-semibold text-slate-700 text-xl">
              Resep Dokter
            </h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-error transition"
          >
            <IoClose size={20} />
          </button>
        </div>

        <div className="px-6 py-5 space-y-6">
          <div className="text-slate-500 font-medium text-base">
            {dataProduct.length > 0 && (
              <ul className="list-disc ml-5 space-y-1">
                {dataProduct.map((item, i) => (
                  <li key={i} className="leading-tight">
                    <span className="text-primary">{item.product_name}</span> x
                    {item.quantity} {item.uom} ({item.notes})
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="w-full">
            <p className="italic text-sm text-error">
              *Resep dokter hanya bisa dikirim 1x ke pasien, pastikan bahwa
              resep sudah benar.
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-2 px-6 py-4 border-t">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border text-md text-gray-600 hover:bg-slate-100 transition"
          >
            Batal
          </button>

          <button
            onClick={handleSend}
            className="px-4 py-2 rounded-lg text-md font-medium text-white transition bg-secondary hover:bg-secondaryHover"
          >
            Kirim Resep
          </button>
        </div>
      </div>
    </div>
  );
};

export const buildPrescriptionText = (prescriptionList) => {
  if (!prescriptionList || prescriptionList.length === 0) return "";

  const lines = prescriptionList
    .map((item) => {
      const notes = item.notes ? ` (${item.notes})` : "";
      return `• ${item.product_name} x${item.quantity}${notes}`;
    })
    .join("\n");

  const payload = JSON.stringify(
    prescriptionList.map((item) => ({
      recipe_id: item.recipe_id,
      product_id: item.product_id,
      product_name: item.product_name,
      quantity: item.quantity,
      price: item.price,
      uom: item.uom,
      indication: item.indication,
      notes: item.notes,
    })),
  );

  return `💊 Resep Obat\n\n${lines}\n\n||PRESCRIPTION_DATA||${payload}||END||`;
};

export default SendPrescriptionDialog;
